import {useEffect} from "react";
import './App.css';
import { useNavigate } from "react-router-dom";
import Users from "./Pages/Users";

function App() {
const navigate = useNavigate();

useEffect(() => {
  if (!localStorage.getItem("token")) {
    navigate("/login")
  } 
}, [navigate]);

  return (
  <div className="App">
    <Users />
  </div>
  );
};

export default App;
